"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateService = void 0;
var moment_1 = __importDefault(require("moment"));
var DATE_FORMAT_DEFAULT = 'MMM DD, YYYY';
/**
 * Date format is different for different languages
 */
var SEISMIC_DATE_FORMAT_FOR_LANGUAGES = {
    'en-US': 'MMM DD, YYYY',
    'en-GB': 'DD MMM YYYY',
    'de-DE': 'DD.MM.YYYY',
    'es-ES': 'DD MMM YYYY',
    'fr-CA': 'DD MMM YYYY',
    'fr-FR': 'DD MMM YYYY',
    'it-IT': 'DD MMM YYYY',
    'ja-JP': 'YYYY/MM/DD',
    'ko-KR': 'YYYY. M. DD.',
    'pt-BR': 'DD/MM/YYYY',
    'zh-CN': 'YYYY年MMMDo',
    'zh-TW': 'YYYY年MMMDo',
    'ru-RU': 'D.MM.YYYY',
    'id-ID': 'dd/MM/yyyy',
    'tr-TR': 'D.MM.YYYY',
};
/**
 * Date format without year
 */
var SEISMIC_DATE_FORMAT_WITHOUT_YEAR_FOR_LANGUAGES = {
    'en-US': 'MMM DD',
    'en-GB': 'DD MMM',
    'de-DE': 'DD.MM',
    'es-ES': 'DD MMM',
    'fr-CA': 'DD MMM',
    'fr-FR': 'DD MMM',
    'it-IT': 'DD MMM',
    'ja-JP': 'MM/DD',
    'ko-KR': 'M. DD.',
    'pt-BR': 'DD/MM',
    'zh-CN': 'MMMDo',
    'zh-TW': 'MMMDo',
    'ru-RU': 'D.MM',
    'id-ID': 'dd/MM',
    'tr-TR': 'D.MM',
};
/**
 * Mapping Seismic language codes to moment locale keys
 */
var SEISMIC_LANG_CODE_MAPPING_TO_MOMENT_LOCALE_KEY = {
    'de-DE': 'de',
    'en-GB': 'en-gb',
    'en-US': 'en',
    'es-ES': 'es',
    'fr-CA': 'fr-ca',
    'fr-FR': 'fr-ch',
    'it-IT': 'it',
    'ja-JP': 'ja',
    'ko-KR': 'ko',
    'pt-BR': 'pt-br',
    'zh-CN': 'zh-cn',
    'zh-TW': 'zh-tw',
    'ru-RU': 'ru',
    'id-ID': 'id',
    'tr-TR': 'tr',
};
var OLD_LANG_CODE_MAPPING_TO_NEW_LANG_CODE = {
    en: 'en-US',
    zh: 'zh-CN',
};
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var DateService = /** @class */ (function () {
    function DateService() {
        var _this = this;
        /**
         * get format string by lang code
         */
        this.getFormatString = function () {
            var locale = moment_1.default.locale();
            var seismicLangCode = _this.getKeyByValueInOBJ(locale, SEISMIC_LANG_CODE_MAPPING_TO_MOMENT_LOCALE_KEY);
            // don't need to handle old lang code here, just use the default ones
            return (SEISMIC_DATE_FORMAT_FOR_LANGUAGES[seismicLangCode] || DATE_FORMAT_DEFAULT);
        };
        /**
         * get format string without year by lang code
         */
        this.getFormatStringWithoutYear = function () {
            var locale = moment_1.default.locale();
            var seismicLangCode = _this.getKeyByValueInOBJ(locale, SEISMIC_LANG_CODE_MAPPING_TO_MOMENT_LOCALE_KEY);
            // don't need to handle old lang code here, just use the default ones
            return (SEISMIC_DATE_FORMAT_WITHOUT_YEAR_FOR_LANGUAGES[seismicLangCode] ||
                DATE_FORMAT_DEFAULT);
        };
        /**
         * get format string For time by lang code
         */
        this.getFormatStringForTimeOnly = function () {
            return 'hh:mm A';
        };
        /**
         * This is to show the common formated date in Seismic apps
         * @param {string} value the date value to be formated
         * @param {string} formatStr the date format to be set
         * @param {boolean} isUtcMode is need to use utc mode of moment.js
         */
        this.formatDateWithoutYear = function (value, formatStr, isUtcMode) {
            if (formatStr === void 0) { formatStr = _this.getFormatStringWithoutYear(); }
            if (isUtcMode === void 0) { isUtcMode = false; }
            var result;
            var m = isUtcMode ? moment_1.default.utc(value) : moment_1.default(value);
            if (m.isValid()) {
                result = m.format(formatStr);
            }
            return result;
        };
        /**
         * This is to show the common formated date in Seismic apps
         * @param {string} value the date value to be formated
         * @param {string} formatStr the date format to be set
         * @param {boolean} isUtcMode is need to use utc mode of moment.js
         */
        this.formatDate = function (value, formatStr, isUtcMode) {
            if (formatStr === void 0) { formatStr = _this.getFormatString(); }
            if (isUtcMode === void 0) { isUtcMode = false; }
            var result;
            var m = isUtcMode ? moment_1.default.utc(value) : moment_1.default(value);
            if (m.isValid()) {
                result = m.format(formatStr);
            }
            return result;
        };
        /**
         * This is to show the common formated time in Seismic apps
         * @param {string} value the time value to be formated
         * @param {string} formatStr the time format to be set
         * @param {boolean} isUtcMode is need to use utc mode of moment.js
         */
        this.formatTime = function (value, formatStr, isUtcMode) {
            if (formatStr === void 0) { formatStr = _this.getFormatStringForTimeOnly(); }
            if (isUtcMode === void 0) { isUtcMode = false; }
            var result;
            var m = isUtcMode ? moment_1.default.utc(value) : moment_1.default(value);
            if (m.isValid()) {
                result = m.format(formatStr);
            }
            return result;
        };
        /**
         * This is to show the common formated date & time in Seismic apps
         * @param {string} value the date value to be formated
         * @param {string} dateFormatStr the date format to be set
         * @param {string} timeFormatStr the time format to be set
         * @param {boolean} isUtcMode is need to use utc mode of moment.js
         *
         * ```typescript
         *   dateService.getDateTimeFormatList(new Date()).join(' ');// return date+time by default
         *   dateService.getDateTimeFormatList(new Date()).reverse().join(' ') //return time+date for some region
         * ```
         */
        this.getDateTimeFormatAsList = function (value, dateFormatStr, //no default value here, inner function will cover it
        timeFormatStr, //no default value here, inner function will cover it
        isUtcMode) {
            var dateStr = _this.formatDate(value, dateFormatStr, isUtcMode);
            var timeStr = _this.formatTime(value, timeFormatStr, isUtcMode);
            return [dateStr, timeStr];
        };
        /**
         * This is to show the common formated date & time in Seismic apps
         * @param {string} value the date value to be formated
         * @param {string} dateFormatStr the date format to be set
         * @param {string} timeFormatStr the time format to be set
         * @param {boolean} isUtcMode is need to use utc mode of moment.js
         */
        this.formatDateTime = function (value, dateFormatStr, //no default value here, inner function will cover it
        timeFormatStr, //no default value here, inner function will cover it
        isUtcMode) {
            var arr = _this.getDateTimeFormatAsList(value, dateFormatStr, timeFormatStr, isUtcMode);
            //arr.reverse();//in case of some region displaying
            return arr.join(' ');
        };
        /**
         * This function is to format the date from now
         * @param {string} value the date value to be formated
         * @param {boolean} isUtcMode is need to use utc mode of moment.js
         */
        this.formatDateFromNow = function (value, isUtcMode) {
            if (isUtcMode === void 0) { isUtcMode = false; }
            var result;
            var m = isUtcMode ? moment_1.default.utc(value) : moment_1.default(value);
            if (m.isValid()) {
                result = m.fromNow();
            }
            return result;
        };
        /**
         * This function is to set global locale code of the date handler
         * @param {string} lang seismic language code.
         */
        this.setLanguage = function (lang) {
            var fixedLang = OLD_LANG_CODE_MAPPING_TO_NEW_LANG_CODE[lang] || lang;
            moment_1.default.locale(SEISMIC_LANG_CODE_MAPPING_TO_MOMENT_LOCALE_KEY[fixedLang]);
        };
    }
    DateService.prototype.getKeyByValueInOBJ = function (value, object) {
        return Object.keys(object)[Object.values(object).findIndex(function (v) { return v === value; })];
    };
    DateService = __decorate([
        CommonService_decorator_1.CommonService('DateService')
    ], DateService);
    return DateService;
}());
exports.DateService = DateService;
//# sourceMappingURL=DateService.js.map